function normalized(vehicle, branded) {
  if (vehicle && vehicle.name) {
    let name = `${vehicle.name} - ${vehicle.version}`;

    if (branded && vehicle.brand) {
      name = `${vehicle.brand} ${name}`;
    }

    return name;
  }

  return 'Veículo desconhecido';
}

export default function vehicleize(vehicle, branded = true) {
  if (vehicle.vehicle_model) {
    return normalized({
      name: vehicle.vehicle_model.model_name,
      brand: vehicle.vehicle_model.brand,
      version: vehicle.vehicle_model.version,
    }, branded);
  }

  return normalized(vehicle, branded);
}
